import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchAllWorkoutPackages,
  fetchWorkoutCategories,
  fetchWorkoutEquipments,
  fetchWorkoutExercise,
  fetchWorkoutExerciseForDropdown,
  fetchWorkoutExerciseStats,
  fetchWorkoutExperiences,
  fetchWorkoutGoal,
  fetchWorkoutMappingStats,
  fetchWorkoutPackageStats,
} from "./workoutSlice";

export const fetchWorkoutExerciseStatsData = createAsyncThunk(
  "api/fetchWorkoutExerciseStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchWorkoutExerciseStats(filters, token);
    return response;
  }
);

export const fetchWorkoutExerciseData = createAsyncThunk(
  "api/fetchWorkoutExerciseData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchWorkoutExercise(filters, token);
    return response;
  }
);

export const fetchWorkoutEquipmentsData = createAsyncThunk(
  "api/fetchWorkoutEquipmentsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchWorkoutEquipments(filters, token);
    return response;
  }
);

export const fetchWorkoutCategoriesData = createAsyncThunk(
  "api/fetchWorkoutCategoriesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchWorkoutCategories(filters, token);
    return response;
  }
);

export const fetchWorkoutExerciseDropdown = createAsyncThunk(
  "api/fetchWorkoutExerciseDropdown",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchWorkoutExerciseForDropdown(filters, token);
    return response;
  }
);

export const fetchWorkoutPackageStatsData = createAsyncThunk(
  "api/fetchWorkoutPackageStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchWorkoutPackageStats(filters, token);
    return response;
  }
);

export const fetchAllWorkoutPackageData = createAsyncThunk(
  "api/fetchAllWorkoutPackageData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAllWorkoutPackages(filters, token);
    return response;
  }
);

export const fetchWorkoutGoalData = createAsyncThunk(
  "api/fetchAllWorkoutGoalData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchWorkoutGoal(filters, token);
    return response;
  }
);

export const fetchWorkoutExperiencesData = createAsyncThunk(
  "api/fetchWorkoutExperiencesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchWorkoutExperiences(filters, token);
    return response;
  }
);

export const fetchWorkoutMappingStatsData = createAsyncThunk(
  "api/fetchWorkoutMappingStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchWorkoutMappingStats(filters, token);
    return response;
  }
);


const workoutSlice = createSlice({
  name: "workoutApi",
  initialState: {
    exerciseStats: null,
    exerciseData: null,
    equipmentsData: null,
    workoutCategoriesData: null,
    exerciseDropdownData: null,
    workoutPackageStats: null,
    workoutPackages: null,
    workoutGoals: null,
    workoutExperiences: null,
    workoutMappingStats: null,

    error: "",

    loading: false,
    dropdownLoading: false,
    catLoading: false,
    statsLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkoutExerciseStatsData.pending, (state) => {
        state.statsLoading = true;
      })
      .addCase(fetchWorkoutExerciseStatsData.fulfilled, (state, action) => {
        state.statsLoading = false;
        state.exerciseStats = action.payload;
      })
      .addCase(fetchWorkoutExerciseStatsData.rejected, (state, action) => {
        state.statsLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchWorkoutExerciseData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWorkoutExerciseData.fulfilled, (state, action) => {
        state.loading = false;
        state.exerciseData = action.payload;
      })
      .addCase(fetchWorkoutExerciseData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchWorkoutEquipmentsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWorkoutEquipmentsData.fulfilled, (state, action) => {
        state.loading = false;
        state.equipmentsData = action.payload;
      })
      .addCase(fetchWorkoutEquipmentsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchWorkoutCategoriesData.pending, (state) => {
        state.catLoading = true;
      })
      .addCase(fetchWorkoutCategoriesData.fulfilled, (state, action) => {
        state.catLoading = false;
        state.workoutCategoriesData = action.payload;
      })
      .addCase(fetchWorkoutCategoriesData.rejected, (state, action) => {
        state.catLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchWorkoutExerciseDropdown.pending, (state) => {
        state.dropdownLoading = true;
      })
      .addCase(fetchWorkoutExerciseDropdown.fulfilled, (state, action) => {
        state.dropdownLoading = false;
        state.exerciseDropdownData = action.payload;
      })
      .addCase(fetchWorkoutExerciseDropdown.rejected, (state, action) => {
        state.dropdownLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchWorkoutPackageStatsData.pending, (state) => {
        state.statsLoading = true;
      })
      .addCase(fetchWorkoutPackageStatsData.fulfilled, (state, action) => {
        state.statsLoading = false;
        state.workoutPackageStats = action.payload;
      })
      .addCase(fetchWorkoutPackageStatsData.rejected, (state, action) => {
        state.statsLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllWorkoutPackageData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllWorkoutPackageData.fulfilled, (state, action) => {
        state.loading = false;
        state.workoutPackages = action.payload;
      })
      .addCase(fetchAllWorkoutPackageData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchWorkoutGoalData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWorkoutGoalData.fulfilled, (state, action) => {
        state.loading = false;
        state.workoutGoals = action.payload;
      })
      .addCase(fetchWorkoutGoalData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchWorkoutExperiencesData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWorkoutExperiencesData.fulfilled, (state, action) => {
        state.loading = false;
        state.workoutExperiences = action.payload;
      })
      .addCase(fetchWorkoutExperiencesData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchWorkoutMappingStatsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWorkoutMappingStatsData.fulfilled, (state, action) => {
        state.loading = false;
        state.workoutMappingStats = action.payload;
      })
      .addCase(fetchWorkoutMappingStatsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default workoutSlice.reducer;
